<div
  rtScrollable
  class="sidebar"
  [class.has-expander]="hasExpander"
  [class.large]="size === 'large'"
  [class.collapsed]="collapseState === 'collapsed'"
  [@collapseHorizontal]="collapseState"
  (@collapseHorizontal.start)="animationEvent.emit($event)"
  (@collapseHorizontal.done)="animationEvent.emit($event)"
>
  <ng-content></ng-content>
</div>
<div *ngIf="hasExpander" class="expander" [class.collapsed]="isMinimized">
  <rt-icon-button
    shape="square"
    [iconName]="isMinimized ? 'chevron-right' : 'chevron-left'"
    variant="transparent-dark"
    (click)="onExpanderClick()"
  >
  </rt-icon-button>
</div>
